import { useState, useEffect } from "react";
import axios from "axios";

interface MainKPIsData {
  amendments_text_followed: number;
  amendments_text_not_followed: number;
  text_not_followed: number;
}

interface UseMainKPIsResponse {
  data: MainKPIsData | null;
  loading: boolean;
  error: string | null;
}

const useMainKPIs = (
  userId?: string,
  startAt?: string,
  endAt?: string
): UseMainKPIsResponse => {
  const [data, setData] = useState<MainKPIsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  //if startAt and endAt are not provided, set to the last 7 days. Format: YYYY-MM-DD
  if (!startAt && !endAt) {
    startAt = new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0];
    endAt = new Date().toISOString().split("T")[0];
  }

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `https://oparl-textprovider-production.up.railway.app/mainKPIs`,
          //`http://localhost:1080/mainKPIs`,
          {
            params: {
              userId: userId,
              startAt: startAt,
              endAt: endAt,
            },
          }
        );
        setData(response.data);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          setError(`Error: ${err.response.statusText}`);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, startAt, endAt]);

  return { data, loading, error };
};

export default useMainKPIs;
